module.exports = __webpack_public_path__ + "static/media/banner-temporario.1fe8655f.jpg";